import axiosInstance from './Instance/axiosInstance';
import { Supplier, SupplierInput } from '../types/supplier';

export const getSuppliers = async (): Promise<Supplier[]> => {
    const response = await axiosInstance.get('/suppliers');
    return response.data;
};

export const createSupplier = async (data: SupplierInput): Promise<Supplier> => {
    const response = await axiosInstance.post('/suppliers', data);
    return response.data;
};

export const updateSupplierApi = async (id: string, data: SupplierInput): Promise<Supplier> => {
    const response = await axiosInstance.put(`/suppliers/${id}`, data);
    return response.data;
};

export const deleteSupplierApi = async (id: string): Promise<void> => {
    await axiosInstance.delete(`/suppliers/${id}`);
};
